import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, ExternalLink, Play, Youtube } from "lucide-react";
import { publicApi } from "./orderApi";
import { QrMedia } from "../public/qr/QrMedia";

const unescape = (s) => { const t = document.createElement("textarea"); t.innerHTML = s || ""; return t.value; };

const Video = ({ s }) => {
  const [failed, setFailed] = useState(false);
  const [play, setPlay] = useState(false);
  const watch = `https://www.youtube.com/watch?v=${s.video_id}`;
  if (failed) return <div className="os-video-fallback" data-testid={`wall-video-fallback-${s.id}`}><Youtube size={28} /><span>This video can’t be embedded here.</span><a className="os-wall-link" style={{ borderColor: "#fff", color: "#fff" }} href={watch} target="_blank" rel="noreferrer">Watch on YouTube <ExternalLink size={14} /></a></div>;
  return (
    <div>
      <div className="os-video" data-testid={`wall-video-${s.id}`}>
        {play ? <iframe title={unescape(s.title) || "Video"} src={`https://www.youtube-nocookie.com/embed/${s.video_id}?rel=0`} allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen onError={() => setFailed(true)} />
          : <button type="button" onClick={() => setPlay(true)} aria-label="Play video" style={{ position: "absolute", inset: 0, width: "100%", display: "grid", placeItems: "center", color: "#fff" }} data-testid={`wall-video-play-${s.id}`}>
            <img src={`https://i.ytimg.com/vi/${s.video_id}/hqdefault.jpg`} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", opacity: .85 }} onError={() => setFailed(true)} />
            <span style={{ position: "relative", width: 64, height: 64, borderRadius: "50%", background: "var(--brand)", display: "grid", placeItems: "center" }}><Play size={28} fill="#fff" /></span>
          </button>}
      </div>
      <a className="os-wall-link" href={watch} target="_blank" rel="noreferrer" data-testid={`wall-video-link-${s.id}`}><Youtube size={16} />Watch on YouTube</a>
    </div>
  );
};

const Section = ({ s }) => (
  <section className="os-wall-section" data-testid={`wall-section-${s.id}`}>
    {s.type === "heading" && <><h2>{unescape(s.title)}</h2>{s.text && <p>{unescape(s.text)}</p>}</>}
    {s.type === "text" && <>{s.title && <h3>{unescape(s.title)}</h3>}<p>{unescape(s.text)}</p></>}
    {s.type === "photo" && <>{s.title && <h3>{unescape(s.title)}</h3>}<div className="os-wall-photo"><QrMedia src={s.image_url} alt={unescape(s.title) || "Photo"} size="large" /></div>{s.text && <p>{unescape(s.text)}</p>}</>}
    {s.type === "youtube" && <>{s.title && <h3>{unescape(s.title)}</h3>}<Video s={s} />{s.text && <p>{unescape(s.text)}</p>}</>}
    {s.type === "link" && <a className="os-wall-link" href={s.url} target="_blank" rel="noreferrer noopener" data-testid={`wall-link-${s.id}`}>{unescape(s.title)} <ExternalLink size={14} /></a>}
  </section>
);

/** Branch Brand Wall — published content only; the homepage hides its entry point when nothing is published. */
export const BrandWall = ({ slug, branch }) => {
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!branch) return;
    window.scrollTo(0, 0);
    publicApi.get(`/${slug}/branches/${branch.id}/brand-wall`).then((r) => setData(r.data)).catch((e) => setErr(e.response?.status === 404 ? "This outlet has not published its Brand Wall yet." : "Could not load the Brand Wall."));
  }, [slug, branch]);
  return (
    <div data-testid="brand-wall">
      <div className="os-menu-top"><button type="button" className="os-icon-btn" style={{ border: 0 }} onClick={() => nav(`/order/${slug}`)} aria-label="Back" data-testid="wall-back"><ArrowLeft size={20} /></button><h2>{branch?.name}</h2><span /></div>
      <div className="os-wall">
        {err && <p className="os-hint" style={{ textAlign: "center", padding: 40 }} data-testid="wall-empty">{err}</p>}
        {!err && !data && <p className="os-hint" style={{ textAlign: "center", padding: 40 }}>Loading…</p>}
        {data?.sections.map((s) => <Section key={s.id} s={s} />)}
      </div>
    </div>
  );
};
